module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_top_campaigns-3babc1e0c3cc03592181eb01458f95c7.png";